<template>
  <div class="flex flex-col fill min-h-full bg-gray-50">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
</script>
